import React from "react";
import _ from "lodash";

var team = [
    {image: "scott.jpg", name: "Scott Graf", title: "President"},
    {image: "jake-1.jpg", name: "Jake Gibel", title: "VP Engineering"},
    {image: "skyanna.jpg", name: "Skyanna Page", title: "VP Product"},
    {image: "taylor-1.jpg", name: "Taylor Ousley", title: "VP Sales and Marketing"},
    {image: "tracy-2.jpeg", name: "Tracy Gaddis", title: "CISO"},
    {image: "robin-holtson.jpg", name: "Robin Holtson", title: "Chief of Staff"},
];

var advisors = [
    {image: "mike-1.jpg", name: "Mike LaCava", title: "Executive Advisor"},
    {image: "joe.jpg", name: "Joe Spatarella", title: "Executive Advisor"},
]

const teamMember = (member, idx) => {

    return (
        <div className="row justify-content-center pb-5 d-flex justify-content-center" key={"r" + idx}>
            {member.map((item, ixd) => (
                <div>
                    <figure className="team-block rounded">
                        <img src={"assets/images/" + item.image} alt="" className="team-img img-fluid ease rounded"/>
                        <figcaption className="ease h-100 left-0 position-absolute rounded top-0 w-100">
                            <div className="d-table h-100 position-relative px-4 w-100">
                                <div className="d-table-cell align-middle text-center">
                                    <span className="d-block font-alt letter-spacing-2 title-medium text-uppercase text-white">{item.name}</span>
                                    <span className="bg-base-color d-inline-block mt-2 sep-line-thick"></span>
                                    <span className="d-block font-alt letter-spacing-2 mt-3 text-medium text-uppercase text-white">{item.title}</span>
                                </div>
                            </div>
                        </figcaption>
                    </figure>
                </div>
                ))}
        </div>
    )
};

export function Team() {
    return(
        <section id="team" className="bg-white">
            <div className="container">
                <div className="row justify-content-center pb-5">
                    <div className="col-lg-9 pb-lg-4 text-center">
                        <h3 className="font-alt font-w-600 letter-spacing-2 text-uppercase title-xs-small title-extra-large-2">Meet
                            The Team</h3>
                        <p className="font-alt mb-0 mt-3 text-xs-large text-uppercase title-medium">We are here to help
                            you with anything you need</p>
                        <span className="bg-base-color d-inline-block mt-4 sep-line-thick-long"></span>
                    </div>

                </div>

                    {_.chunk(team, 6).map((member, idx) => (
                        teamMember(member, idx)
                    ))}

                    {_.chunk(advisors, 3).map((member, idx) => (
                        teamMember(member, idx)
                    ))}

            </div>

        </section>
    )
}
